// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/SearchType.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file Enumerations/SearchType.proto.
 */
export const file_Enumerations_SearchType: GenFile = /*@__PURE__*/
  fileDesc("Ch1FbnVtZXJhdGlvbnMvU2VhcmNoVHlwZS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqdgoKU2VhcmNoVHlwZRIYChRTRUFSQ0hfVFlQRV9DT05UQUlOUxAAEhYKElNFQVJDSF9UWVBFX0VRVUFMUxABEhsKF1NFQVJDSF9UWVBFX1NUQVJUU19XSVRIEAISGQoVU0VBUkNIX1RZUEVfRU5EU19XSVRIEANCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw");

/**
 * Determines how a search text inside a single column is matched.
 *
 * @generated from enum time_tracking.enumerations.SearchType
 */
export enum SearchType {
  /**
   * The search text has to be contained somewhere in the column.
   *
   * @generated from enum value: SEARCH_TYPE_CONTAINS = 0;
   */
  CONTAINS = 0,

  /**
   * The column has to contain exactly the search text.
   *
   * @generated from enum value: SEARCH_TYPE_EQUALS = 1;
   */
  EQUALS = 1,

  /**
   * The column has to start with the search text.
   *
   * @generated from enum value: SEARCH_TYPE_STARTS_WITH = 2;
   */
  STARTS_WITH = 2,

  /**
   * The column has to end with the search text.
   *
   * @generated from enum value: SEARCH_TYPE_ENDS_WITH = 3;
   */
  ENDS_WITH = 3,
}

/**
 * Describes the enum time_tracking.enumerations.SearchType.
 */
export const SearchTypeSchema: GenEnum<SearchType> = /*@__PURE__*/
  enumDesc(file_Enumerations_SearchType, 0);

